<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() { return this.$route.path }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  flex: 1;
  padding: 16px;
  background: #f0f2f5;
  overflow-y: auto;
}
</style>
